import { useEffect, useRef, useState } from "react";
import { financeAssets } from "../../../services/constant";
import { LineChart } from '@mui/x-charts/LineChart';

const tData = [300, 250, 200, 300, 350, 400, 500, 500, 400, 200, 300, 400];
const cData = [210, 130, 150, 420, 400, 350, 300, 330, 360, 320, 300, 270];
const rData = [380, 350, 390, 400, 430, 460, 550, 600, 370, 350, 300, 340];
const xLabels = [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Mrs',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez',
];

const Dashboard = () => {
    const chartContainerRef = useRef(null);
    const [chartWidth, setChartWidth] = useState(0);


    useEffect(() => {
        if (chartContainerRef.current) {
            setChartWidth(chartContainerRef.current.offsetWidth);
        }

        const handleResize = () => {
            if (chartContainerRef.current) {
                setChartWidth(chartContainerRef.current.offsetWidth);
            }
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    return (
        <div className="flex flex-col gap-[16px] mt-[5.5rem] max-w-[80%] w-full self-center">
            <div className="flex flex-row gap-[16px] w-full">
                <div className="w-full rounded-[11px] bg-white p-[1.4rem] flex flex-col gap-[2.2rem]">
                    <div className="flex flex-row gap-[1.6rem]">
                        <img src={financeAssets.ic_1} className="w-[4.4rem] h-[4.4rem]" />
                        <p className="font-16-400 text-[#7385AA] self-center"> Receita Total </p>
                    </div>
                    <p className="font-color font-29-900">2454,34€</p>
                </div>

                <div className="w-full rounded-[11px] bg-white p-[1.4rem] flex flex-col gap-[2.2rem]">
                    <div className="flex flex-row gap-[1.6rem]">
                        <img src={financeAssets.ic_2} className="w-[4.4rem] h-[4.4rem]" />
                        <p className="font-16-400 text-[#7385AA] self-center"> Disponível para recebimento </p>
                    </div>
                    <p className="font-color font-29-400">105€</p>
                </div>


                <div className="w-full rounded-[11px] bg-white p-[1.4rem] flex flex-col gap-[2.2rem]">
                    <div className="flex flex-row gap-[1.6rem]">
                        <img src={financeAssets.ic_3} className="w-[4.4rem] h-[4.4rem]" />
                        <p className="font-16-400 text-[#7385AA] self-center"> Valor Rejeitado </p>
                    </div>
                    <p className="font-color font-29-400">0€</p>
                </div>

            </div>
            <div ref={chartContainerRef} className="bg-white py-[2.2rem] px-[4.5rem] rounded-[1.1rem]">
                <h4 className="font-16-400 text-[#7385AA] mb-[1.5rem]">Resumo Anual</h4>
                <LineChart
                    width={chartWidth - 50}
                    height={300}
                    series={[
                        { curve: "linear", data: tData, label: 'Total Recebido', showMark: false , color: "#1FD2DB",},
                        { curve: "linear", data: cData, label: 'Co-pagamento', showMark: false ,color: "#9C55EC", },
                        { curve: "linear", data: rData, label: 'Reembolso Seguradora', showMark: false , color: "#B1EE15", },
                    ]}
                    xAxis={[{ scaleType: 'point', data: xLabels }]}
                    yAxis={[
                        {
                            min: 0,
                            max: 800,
                            scaleType: 'linear',
                            tickFormatter: (value) => `${value}€`,
                            
                        },
                    ]}
                    sx={{
                        '&.MuiChartsLegend-row': {

                        },
                    }}
                    grid={{ vertical: true, horizontal: true }}
                />

            </div>

        </div>
    );
}
export default Dashboard;